<template>
  <div class="top-bar">
    <span class="bar-item-abs-logo">
      <img
        class="abs-logo-img"
        src="@/assets/img/ABS-Logo-mobile.png"
        alt="ABS logo"
      />
      <span>ABS系统平台</span>
    </span>
    <span class="bar-item">
      <a href="mailto:IB_BTrustees_ABS@cicc.com.cn"
        ><img class="bar-item-logo" src="@/assets/img/email-mobile.png"
      /></a>
    </span>
    <span class="bar-item"
      ><img class="bar-item-logo" src="@/assets/img/telephone-mobile.png"
    /></span>
    <span class="bar-item">
      <img class="bar-item-logo" src="@/assets/img/weichat-mobile.png" />
      <a-popover
        placement="bottom"
        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
      >
        <template #content>
          <span>敬请期待</span>
        </template>
        <a href="javascript:" data-under-construction></a>
      </a-popover>
    </span>
    <span class="bar-item">
      <img class="bar-item-logo" src="@/assets/img/client-mobile.png" />
      <a-popover
        placement="bottom"
        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
      >
        <template #content>
          <span>敬请期待</span>
        </template>
        <a href="javascript:" data-under-construction></a>
      </a-popover>
    </span>
  </div>
  <header class="site-header">
    <div class="detail-title">CICC固定收益</div>
    <div>
      <span class="production-name-tag">
        <img
          class="icon-production-name"
          src="@/assets/img/production-logo.png"
        />
        <span class="production-name">产品名称</span>
      </span>
    </div>
    <div class="special-plan-title">{{ productName }}</div>
  </header>
</template>
<script>
import { toRefs } from "vue";
import "../../config/rem";
export default {
  name: "DefaultHeader",
  props: {
    productName: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { productName } = toRefs(props);
  },
};
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.top-bar :deep() {
  height: 60px;
  color: #333333;
  background: #ffffff;
  line-height: 50px;
  & .bar-item-abs-logo {
    margin: 0 271px 0 24px;
    font-size: 24px;
    @media only screen and (max-width: 360px) {
      margin-right: 220px;
    }
    & .abs-logo-img {
      margin-right: 1rem;
      width: 38px;
      height: 38px;
    }
  }
  & .bar-item {
    margin: 0 20px;
    & .bar-item-logo {
      width: 24px;
      height: 24px;
    }
  }
}

.site-header {
  height: 359px;
  background-image: url("~@/assets/img/detail-header.png");
  background-size: 100% 100%;
  padding-left: 8%;

  .detail-title {
    padding-top: 61px;
    color: #910e0e;
    font-size: 53px;
    font-family: Helvetica;
  }

  .icon-production-name {
    vertical-align: sub;
    margin: 10px 12px 0 4px;
    height: 30px;
    width: 30px;
  }
  .production-name {
    font-size: 24px;
    font-weight: 400;
    color: #000000;
  }

  .special-plan-title {
    padding-left: 45px;
    font-size: 30px;
    font-weight: 500;
    color: #000000;
    line-height: 36px;
    text-shadow: 10px 0 25px #ffffff;
  }
}
</style>
